var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artwork, title) {
buf.push("<h1 class=\"iq-headline\">");
if ( artwork.related().partner.get('pre_qualify'))
{
buf.push(jade.escape(null == (jade_interp = title) ? "" : jade_interp));
}
else
{
buf.push("<span>" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</span><span>(Optional)</span>");
}
buf.push("</h1><form class=\"iq-form stacked-form\"><div class=\"iq-form-errors js-form-errors\"></div><div class=\"js-user-interests\"></div><div class=\"iq-sticky-spacer\"></div><div class=\"iq-sticky-bottom\"><button type=\"submit\" class=\"avant-garde-button-black is-block iq-next\">Next</button></div></form>");}.call(this,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
module.exports = template;